module.exports = __webpack_public_path__ + "01e8feeafd92fe159df2ddf47e6a6627.svg";